import { useEffect, useState } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import DataTable from "examples/Tables/DataTable";
import { Card, Box } from "@mui/material";
import userProfile from "assets/images/user-profile.png";
import ArgonSelect from "components/ArgonSelect";
import { useParams } from "react-router-dom";
import ArgonButton from "components/ArgonButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Avatar from "@mui/material/Avatar";
import { useNavigate, useLocation } from "react-router-dom";
import ActivityReviewPanelModal from "layouts/dashboards/Components/ReviewPanels/ActivityReviewPanelModal";
import ChatReviewPanelModal from "layouts/dashboards/Components/ReviewPanels/ChatReviewPanelModal";
import ProfileReviewPanelModal from "layouts/dashboards/Components/ReviewPanels/ProfileReviewPanelModal";
import { getReports } from "services/reportService";
import CircularProgress from "@mui/material/CircularProgress";
import {
  DATE_FILTER,
  STATUS_FILTER,
  REPORT_REASON_FILTER,
  CONTENT_TYPE_FILTER,
} from "./consts";
import "./Reports.css";

function ReportsAgainst() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = location.state?.user;
  const [flaggedContent, setFlaggedContent] = useState([]);
  const [openReviewPanelModal, setOpenReviewPanelModal] = useState(false);
  const [reviewPanelType, setReviewPanelType] = useState(null);
  const [dateFilter, setDateFilter] = useState(DATE_FILTER[0]);
  const [statusFilter, setStatusFilter] = useState(STATUS_FILTER[0]);
  const [reportReasonFilter, setReportReasonFilter] = useState(
    REPORT_REASON_FILTER[0]
  );
  const [contentTypeFilter, setContentTypeFilter] = useState(
    CONTENT_TYPE_FILTER[0]
  );
  const [loading, setLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    setLoading(true);
    getReports(
      dateFilter.value !== "All" ? dateFilter.value : null,
      statusFilter.value !== "All" ? statusFilter.value : null,
      reportReasonFilter.value !== "All" ? reportReasonFilter.value : null,
      contentTypeFilter.value !== "All" ? contentTypeFilter.value : null,
      null,
      id
    )
      .then((data) => {
        if (data.success && data.data && data.data.reports) {
          const transformedReports = data.data.reports.map((report) => ({
            _id: report._id,
            reported_user: report.reportedAgainst?.name || "N/A",
            content_type: report.contentType,
            report_reason: report.reason,
            status: report.status,
            date: new Date(report.createdAt).toISOString().split("T")[0],
            action_taken: report.actionTaken,
            date_and_time_of_action: new Date(
              report.updatedAt
            ).toLocaleString(),
          }));
          setFlaggedContent(transformedReports);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    dateFilter,
    statusFilter,
    reportReasonFilter,
    contentTypeFilter,
    id,
    refresh,
  ]);

  const handleCloseReviewPanelModal = () => {
    setOpenReviewPanelModal(false);
    setReviewPanelType(null);
    setSelectedReport(null);
  };

  const columns = [
    {
      Header: "Reported User",
      accessor: "reported_user",
      Cell: ({ row }) => (
        <ArgonBox display="flex" alignItems="center">
          <img
            src={userProfile}
            alt="avatar"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              marginRight: 10,
            }}
          />
          <ArgonTypography className="reports-table-text">
            {row.original.reported_user}
          </ArgonTypography>
        </ArgonBox>
      ),
    },
    {
      Header: "Content Type",
      accessor: "content_type",
      Cell: ({ row }) => (
        <ArgonTypography className="reports-table-text">
          {row.original.content_type}
        </ArgonTypography>
      ),
    },
    {
      Header: "Report Reason",
      accessor: "report_reason",
      Cell: ({ row }) => (
        <ArgonTypography className="reports-table-text">
          {row.original.report_reason}
        </ArgonTypography>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
        <span
          className="reports-table-text"
          style={{
            background: "#f6f7f8",
            borderRadius: 12,
            padding: "4px 16px",
          }}
        >
          {row.original.status}
        </span>
      ),
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: ({ row }) => (
        <ArgonTypography className="reports-table-text">
          {row.original.date}
        </ArgonTypography>
      ),
    },
    {
      Header: "Action Taken",
      accessor: "action_taken",
      Cell: ({ row }) => (
        <ArgonTypography className="reports-table-text">
          {row.original.action_taken}
        </ArgonTypography>
      ),
    },
    {
      Header: "Date and Time of Action",
      accessor: "date_and_time_of_action",
      Cell: ({ row }) => (
        <ArgonTypography className="reports-table-text">
          {row.original.date_and_time_of_action}
        </ArgonTypography>
      ),
    },
    {
      Header: "Action",
      accessor: "view_details",
      Cell: ({ row }) => (
        <ArgonTypography
          className="reports-table-text reports-view-details-text"
          fontWeight="medium"
          onClick={() => {
            setSelectedReport(row.original);
            if (row.original.content_type === "activity") {
              setOpenReviewPanelModal(true);
              setReviewPanelType("activity");
            } else if (row.original.content_type === "activity_message") {
              setOpenReviewPanelModal(true);
              setReviewPanelType("activity_message");
            } else if (row.original.content_type === "user") {
              setOpenReviewPanelModal(true);
              setReviewPanelType("user");
            }
          }}
        >
          View Details
        </ArgonTypography>
      ),
    },
  ];

  return (
    <>
      <ArgonBox pb={3}>
        <ArgonButton
          color="white"
          onClick={() => navigate("/admin/user-history")}
        >
          <ArrowBackIcon sx={{ mr: 1 }} />
          <ArgonTypography variant="h5" fontWeight="medium">
            Back
          </ArgonTypography>
        </ArgonButton>
        <ArgonBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
          p={2}
          sx={{
            minHeight: "120px",
            backgroundColor: "#fff",
            position: "relative",
            borderRadius: 4,
          }}
        >
          <ArgonBox display="flex" alignItems="center" gap={2}>
            <Avatar src={user?.avatar || userProfile} />
            <ArgonTypography variant="h5" fontWeight="medium">
              {user.name}
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
      </ArgonBox>
      <ArgonBox>
        <Card
          sx={{
            overflow: "visible",
            padding: 3,
            pb: flaggedContent.length > 0 ? 0 : 6,
          }}
        >
          <ArgonBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            pl={3}
            pb={3}
            pr={3}
          >
            <ArgonTypography variant="h5" fontWeight="medium">
              Reports Against
            </ArgonTypography>
            <ArgonBox
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="flex-end"
              alignItems="center"
              gap={2}
            >
              <ArgonSelect
                value={dateFilter}
                options={DATE_FILTER}
                onChange={setDateFilter}
                hasShadow
                width="80px"
              />
              <ArgonSelect
                value={statusFilter}
                options={STATUS_FILTER}
                onChange={setStatusFilter}
                hasShadow
                width="95px"
              />
              <ArgonSelect
                value={reportReasonFilter}
                options={REPORT_REASON_FILTER}
                onChange={setReportReasonFilter}
                hasShadow
                width="150px"
              />
              <ArgonSelect
                value={contentTypeFilter}
                options={CONTENT_TYPE_FILTER}
                onChange={setContentTypeFilter}
                hasShadow
                width="140px"
              />
            </ArgonBox>
          </ArgonBox>
          {loading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : (
            <DataTable
              loading={loading}
              table={{ columns, rows: flaggedContent }}
              entriesPerPage={false}
              canSearch={false}
              showTotalEntries={false}
              pagination={false}
            />
          )}
          {openReviewPanelModal &&
            (reviewPanelType === "activity" ? (
              <ActivityReviewPanelModal
                open={openReviewPanelModal}
                handleClose={handleCloseReviewPanelModal}
                _id={selectedReport._id}
                onUpdate={() => setRefresh(!refresh)}
              />
            ) : reviewPanelType === "activity_message" ? (
              <ChatReviewPanelModal
                open={openReviewPanelModal}
                handleClose={handleCloseReviewPanelModal}
                _id={selectedReport._id}
                onUpdate={() => setRefresh(!refresh)}
              />
            ) : (
              <ProfileReviewPanelModal
                open={openReviewPanelModal}
                handleClose={handleCloseReviewPanelModal}
                _id={selectedReport._id}
                onUpdate={() => setRefresh(!refresh)}
              />
            ))}
        </Card>
      </ArgonBox>
    </>
  );
}

export default ReportsAgainst;
